const SHOP_APOTHEKE_SELLER_ID = 'shop-apotheke'

// for not marketplace products, there is no sellerId available
export const cartIntermediateCrossSellAccessorIsSellerShopApotheke = (
  sellerId: string,
): boolean => {
  if (!sellerId) {
    return true
  }

  return sellerId === SHOP_APOTHEKE_SELLER_ID
}
